module.exports = __webpack_public_path__ + "static/media/sourcesanspro-lightitalic-webfont.ffb6369e.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-lightitalic-webfont.woff2
// module id = 503
// module chunks = 0